export const m = {
  EnterID: "Tada ID इनपुट पर क्लिक करें",
  "select-specifications": "रिचार्ज विनिर्देशों का चयन करने के लिए क्लिक करें",
  "check-account": "रिचार्ज अकाउंट चेक करें",
  whatID: "Tada ID क्या है ？",
  getID: "Tada ID इनपुट करें",
  maskgetID: " Tada ID इनपुट करें",
  "toastTips-format-error": "गलत इनपुट प्रारूप",
  "toastTips-no-exist": "यह ID मौजूद नहीं है",
  toastTipsPlease: "कृपया पहले से रिचार्ज अकाउंट चेक करें",
  "common-problem": "सामान्य समस्या",
  "transaction-succeeded": "सौदा सफल है",
  "transaction-failed": "सौदा विफल है",
  "transaction-cancel": "सौदा का खात्मा किया गया है",
  "whether-account":
    "1. रिचार्ज के बाद मैं कैसे जांचें कि क्या पैसा प्राप्त किया है या नहीं?",
  "answer-whether-account":
    "रिचार्ज के बाद, आप हीरे की जांच करने के लिए app में [मेरा] - [वॉलेट] पर वापस जा सकते हैं",
  "no-account": "2.रिचार्ज के बाद अगर पैसा प्राप्त नहीं किया तो कैसे करें?",
  "answer-no-account":
    "कृपया app में अपना प्रश्न [संदेश] - [आधिकारिक संदेश] - [प्रतिक्रिया और मदद] प्रस्तुत करें और निम्नलिखित जानकारी प्रदान करें। हमारी ग्राहक सेवा आपकी मदद करे।",
  "recharge-money": "1. रिचार्ज राशि और खाता ID",
  "recharge-time": "2. रिचार्ज का समय और तारीख",
  "recharge-shot": "3. सफल भुगतान के स्क्रीनशॉट",
  "recharge-wrong":
    "3.गलत रिचार्ज का अकाउंट और गलत रिचार्ज की राशि तो कैसे करें",
  "answer-recharge-wrong":
    "भुगतान पासवर्ड दर्ज करने से पहले, खरीदने से पहले रिचार्ज अकाउंट ID और रिचार्ज राशि की जानकारी सावधानी से पुष्टि करें। गलत रिचार्ज की राशि वापस नहीं की जा सकती। गलत चार्ज खाते के लिए, आप वास्तविक रिचार्ज के ID उपयोगकर्ता से संपर्क करने की कोशिश करें और दूसरे पक्ष से बातचीत कर सकते हैं कि क्या वे रिचार्ज के लिए आपको इनाम देने के लिए तैयार हैं।",
  refund: "4.वापसी",
  "answer-refund":
    '"माफ़ कीजिये!Tada वर्तमान में किसी भी रूप की वापसी का समर्थन नहीं करता।"',
  "buy-enter-link":
    '"आप हीरे खरीदने के लिए लिंक के माध्यम से कर सकते हैं，<a class="web-link" href="https://pay.tadachat.live/" >https://pay.tadachat.live</a> इस लिंक को कॉपी करें , मोबाइल ब्राउज़र में खोलें और खरीद पृष्ठ दर्ज करें। खाता संख्या की जांच करने के बाद उपयुक्त विनिर्देशों का चयन करें और भुगतान करने के लिए उपयुक्त भुगतान विधि का उपयोग करें। कम कीमत और उच्च डिस्काउंट।"',
  "buy-notice-a":
    "नोट: <a>pay.tadachat.live</a> ही Tada की एकमात्र आधिकारिक हीरे खरीदमे का वेबसाइट है",
  replace: "बदलें",
  sureBtn: "निर्धारित",
  "pay-style": "भुगतान विधि चुनें",
  goBack: "वापस होम पेज पर",
  toastTips: "Tada ID इनपुट करें",
  rechargeFAQ_title: "सामान्य समस्या",
  PayStatusSuccess_title: "सौदा सफल है",
  PayStatusFail_title: "सौदा विफल है",
  PayStatusCancel_title: "सौदा का खात्मा किया गया है",
  Diamonds_title: "Tada आधिकारिक डायमंड रिचार्ज वेबसाइट",
  "buy-notice":
    "नोट pay.Tadachat.live Tada की एकमात्र आधिकारिक हीरा खरीदने वाली वेबसाइट है, कृपया [संदेश] - [आधिकारिक समाचार] - [प्रतिक्रिया और सहायता] पर जाएं।",
  RechargeHelp_title: "रिचार्ज मदद",
  openAPP: "ओपन फेसकास्ट एपीपी",
  "buy-diamonds-tit": "हीरा सेवाएं खरीदें",
  description:
    "Tada एकल आधिकारिक डायमंड रिचार्ज वेबसाइट है, Tada एक अंतर्राष्ट्रीय सामाजिक सॉफ्टवेयर है जिसका उपयोग दुनिया भर के 150 से अधिक देशों और क्षेत्रों में किया जाता है",
  keywords:
    "Tada रिचार्ज, Tada डायमंड रिचार्ज, Tada आधिकारिक रिचार्ज, Tada आधिकारिक रिचार्ज वेबसाइट",
  "payforType": "  रिचार्ज विधि",
  trueText: " निर्धारित",
  falseText: " रद्द करना",
  alertShowTxt1: " क्या आप",
  alertShowTxt3: " हीरे को रिचार्ज करने के लिए",
  alertShowTxt5: " का उपयोग करना सुनिश्चित करते हैं?",

  EnterIDTip: "फेसकास्ट त्वरित रिचार्ज",

  scanLogin:
    " खाता गोपनीयता और सुरक्षा के लिए, कृपया लॉग इन करने के लिए कोड को स्कैन करें",
  scanTip:
    ' टिप: लॉग इन करने के लिए कोड को स्कैन करने के लिए फेसकास्ट "पर्सनल सेंटर / डायनामिक्स" के ऊपरी दाएं कोने पर "स्कैन" पर क्लिक करें। साथ ही, यह QR कोड स्क्रीनशॉट की पहचान करके लॉग इन करने का समर्थन करता है',
  scanVersion:
    " कृपया फेसकास्ट को %s संस्करण में अपग्रेड करें और लॉग इन करने के लिए कोड को स्कैन करें",
  delAccount: " खाता हटाना",
  logout: " छोड़ना",

  submit: "प्रस्तुत करना",
  email_place_holder: "अपना ईमेल पता दर्ज करें",
  contact_email: "ई - मेल से संपर्क करे",
  provide_email:
    "भुगतान सूचना प्राप्त करने के लिए कृपया अपना ईमेल पता प्रदान करें",
  email_address: "ईमेल पता",
};



// WEBPACK FOOTER //
// ./src/lang/hi.js